import { formatQuantity } from "@common/utils/string";
import MetabotUsageGraph from "./UsageGraph";
import { ManageAddOnLink } from "@components/account/plan/ManageAddOns/ManageAddOns.components";
import { AddOnCard } from "@addons/components/AddOnCard";
import { IAddOnSlotProps, IPrepaidAddOnDescriptor } from "../types";
import { subscribedTier, tieredTotal } from "../utils";

export function ManageCard({
  addOn: ctx,
}: IAddOnSlotProps<IPrepaidAddOnDescriptor>) {
  const { subscribed, purchase, canChangeSubscription, isYearly } = ctx;
  const tier = subscribedTier(ctx);

  return (
    <AddOnCard
      isYearly={isYearly}
      productType="metabase-ai-tiered"
      title={ctx.title}
      detail={
        subscribed
          ? `${tier?.name || ""} (${formatQuantity(subscribed.prepaid_units)} requests)`
          : null
      }
      price={tieredTotal(ctx)}
      description="Metabot helps you move faster and understand your data better. You can ask it to generate SQL, and build or explain queries."
      usage={subscribed && <MetabotUsageGraph addOn={ctx} />}
      extra={
        canChangeSubscription && (
          <ManageAddOnLink
            hasAddOn={!!subscribed}
            href={`/account/${purchase.id}/metabot`}
          />
        )
      }
    />
  );
}
